'use strict';

var cov_247corgcli = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/product/lib/constants.js',
      hash = '4b2f949f0233cb812f1bc1bde5e76031e1eb5b63',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/product/lib/constants.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 31
        },
        end: {
          line: 21,
          column: 1
        }
      },
      '1': {
        start: {
          line: 23,
          column: 35
        },
        end: {
          line: 26,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0,
      '1': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProductTypeEnum = exports.ProductTypeEnum = (cov_247corgcli.s[0]++, {
  SERVICE: 'SERVICE',
  VOUCHER: 'VOUCHER',
  DONATION: 'DONATION',
  GOODS: 'GOODS',
  PACKAGE: 'PACKAGE',
  EVENT: 'EVENT',
  VISIT: 'VISIT',
  TOUR: 'TOUR',
  PARKING: 'PARKING',
  SEASON_TICKET: 'SEASON_TICKET',
  SPORTING_EVENT: 'SPORTING_EVENT',
  MEMBERSHIP: 'MEMBERSHIP',
  TIMESLOT_PASS: 'TIMESLOT_PASS',
  VISIT_PASS: 'VISIT_PASS',
  PASS: 'PASS',
  OPEN_PASS: 'OPEN_PASS',
  HOSPITALITY: 'HOSPITALITY',
  HOSPITALITY_BUNDLE: 'HOSPITALITY_BUNDLE',
  UNKNOWN: 'UNKNOWN'
});

var HospitalityTypeEnum = exports.HospitalityTypeEnum = (cov_247corgcli.s[1]++, {
  PRIVATE: 'PRIVATE',
  SHARED: 'SHARED'
});